var $ = require('jquery')
  , whenCompontentExist = require('./mods/whenCompontentExist')
  , whenQueryEqual = require('./mods/whenQueryEqual')
  , applyActionWhenClicked = require('./mods/applyActionWhenClicked')
  , eitherWeixinBrowser = require('./mods/eitherWeixinBrowser')
  , engageCurrentGame = require('./components/engageCurrentGame')
  , downloadCurrentApk = require('./components/downloadCurrentApk')
  , showWeixinOverlay = require('./components/showWeixinOverlay')

$(function() {
  whenCompontentExist('.btn-engage-current-game')
    .done(applyActionWhenClicked(engageCurrentGame))

  whenQueryEqual('f', 'scan')
    .then(function() {
      eitherWeixinBrowser()
        .then(showWeixinOverlay, downloadCurrentApk)
    })
})
